import './RapydCheckoutPage.scss';

import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import CacheData from "../../common/utils/cacheData";
import BuildingTitle from "../../common/buildingTitle";
import {fetchBuildingData} from "../../store/buildings/actions";
import {useDispatch, useSelector} from "react-redux";

export function RapydCheckoutPage(props) {

    const { cartID } = props.match.params;
    const { t } = useTranslation();
    document.title = t('titles.make_payment');

    const [checkoutStatus, setCheckoutStatus] = useState();
    const [apartmentNumber, setApartmentNumber] = useState();
    const [checkoutPageUrl, setCheckoutPageUrl] = useState();
    const currentBuildingData = useSelector(state => state.buildings.currentBuildingData);
    const dispatch = useDispatch();

    useEffect(() => {
        const data = CacheData.fetchCache('createCartResponse', { cartID });
        setCheckoutPageUrl(data?.rapydCheckoutPage);
        setApartmentNumber(data?.apartmentNumber);
        const buildingID = data?.buildingID;
        const action = async () => await dispatch(fetchBuildingData({ buildingID }));
        if (currentBuildingData?.id !== buildingID) {
            (action)();
        }
    }, [cartID]);

    const handleIframeMessage = async (event) => {
        const data = event.data;
        switch (data) {
            case 'complete_checkout':
            case 'complete_payment':
                window.location.href = `/status/${cartID}`
                break;
            case 'cancel_checkout':
            case 'error_payment':
                // TODO: implement me
                setCheckoutStatus(data);
                break;
            default:
                // there may be tons of such events from browser plugins
                break;
        }
    };

    useEffect(() => {
        window.addEventListener("message", handleIframeMessage);
        return () => window.removeEventListener("message", handleIframeMessage);
    }, []);

    if (checkoutPageUrl == null) {
        return <div className="RapydCheckoutPage container" />;
    }

    return <div className="RapydCheckoutPage container">

        <div className="row">
            <div className="p-dept-section col-md-12">
                <BuildingTitle address={currentBuildingData.address} apartmentNumber={apartmentNumber} />
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                { checkoutStatus == null &&  <div class="iframe-container"><iframe title="Rapyd Checkout Page"  src={checkoutPageUrl} allowpaymentrequest="true" allow="payment" /></div> }
                { checkoutStatus === 'cancel_checkout' &&  <p>Operation cancelled</p> }
                { checkoutStatus === 'error_payment' &&  <p>An error occurred</p> }
            </div>
        </div>

    </div>;

}
